<template>
  <div class="img-big-box">
    <div class="goods-detail">
      <div class="main-img-box">
        <div class="main-img">
          <img :src="imgUrl" alt="">
        </div>
        <div class="img-list">
          <div class="img-box">
            <div class="icon-box el-icon-arrow-left" @click="prevBtn"></div>
            <div class="imgs">
              <ul class="uls" ref="uls">
                <li :class="{active : activeindex == index}" v-for="(item, index) in imgList" :key="index"
                  @click="clickImgFun(item,index)">
                  <img :src="item.SpuPicUrl" alt="">
                </li>
              </ul>
            </div>
            <div class="icon-box el-icon-arrow-right" @click="nextBtn"></div>
          </div>
        </div>
      </div>
      <div class="img-right">
        <div class="txt-box">{{goodsData.ProName}}</div>
        <div class="price-box">
            <div class="price">
              <span class="price-title">售价</span>
              <div class="gift-list">
                <span class="redTxt">¥{{goodsData.MinPrice}}</span>
                <span class="lineTxt">¥{{goodsData.MinLinePrice}}</span>
              </div>
            </div>
            <div class="price">
              <span class="price-title">赠品</span>
              <div class="gift-list">
                <span class="item-gift" v-for="(gift, giftId) in giftsData" :key="giftId">{{gift.ProName}}</span>
                <span v-if="giftsData.length <= 0" style="color:#f40000;">暂无赠品</span>
              </div>
            </div>
            <div class="price">
              <span class="price-title">红包</span>
              <div class="gift-list">
                <span class="item-red" v-for="(envelope, envelopeId) in envelopeList" :key="envelopeId">¥{{envelope.Amount}}</span>
                <span v-if="envelopeList.length <= 0" style="color:#f40000;">暂无红包</span>
              </div>
            </div>
            <!-- <div class="price">
              <span class="price-title">优惠券</span>
              <div class="gift-list">
                <span>¥38335.00</span>
                <span>¥88888.00</span>
              </div>
            </div> -->
        </div>
        <div class="specs-box">
          <div class="specs"><span class="specs-title">服务</span><span>原装正品·7天退货·闪发货</span></div>
          <!-- <div class="specs">
            <span class="specs-title">商品型号</span>
            <div class="specs-list">
              <span class="specs-item">原装正品·7天退货·闪发货</span>
            </div>
          </div>
          <div class="specs">
            <span class="specs-title">商品容积</span>
            <div class="specs-list">
              <span class="specs-item">原装正品·7天退货·闪发货</span>
            </div>
          </div>
          <div class="specs">
            <span class="specs-title">制冷控制</span>
            <div class="specs-list">
              <span class="specs-item">原装正品·7天退货·闪发货</span>
            </div>
          </div>
          <div class="specs">
            <span class="specs-title">能效等级</span>
            <div class="specs-list">
              <span class="specs-item">原装正品·7天退货·闪发货</span>
            </div>
          </div>
          <div class="specs">
            <span class="specs-title">控湿方式</span>
            <div class="specs-list">
              <span class="specs-item">原装正品·7天退货·闪发货</span>
            </div>
          </div> -->
        </div>
        <div class="btn-box">
          <div class="inputNum">
            <span>数量</span>
            <el-input-number style="width:100px;" :precision="0" :min="1" controls-position="right" v-model="skuNumber"></el-input-number>
          </div>
          <div class="btn borBtn" @click="addToCart">加入购物车</div>
          <div class="btn bgBtn" @click="buyNow">立即购买</div>
          <div class="shoucang"><span class="icon-sc">收藏</span></div>
          <div class="kefu"><span class="icon-kf">客服</span></div>
        </div>
      </div>
      <div class="shop">
        <div class="shop-name">
          <span>洪伟的专卖店</span>
        </div>
        <div class="score">
          <span>综合评分：5分</span>
        </div>
        <div class="shop-score">
          <p>店铺评分：</p>
          <ul>
            <li><span>描述相符：5分</span></li>
            <li><span>服务态度：5分</span></li>
            <li><span>发货速度：5分</span></li>
          </ul>
        </div>
        <div class="describe">
          <p><span>公司名称：</span><span>洪伟的专卖店</span></p>
          <p><span>所在地：</span><span>上海市杨浦区</span></p>
          <p><span>营业执照：</span><span>正常</span></p>
        </div>
        <div class="shop-btn">
          <el-button type="text" @click="gotoShop">进入店铺</el-button>
        </div>
      </div>
    </div>
    <div class="main-bottom">
      <div class="goods-list">
        <div class="lable-txt">相关推荐</div>
        <div class="item-list">
          <ax-goods v-for="(item,index) in recommendList" :key="index" :goodsData="item"></ax-goods>
        </div>
      </div>
      <div class="content">
        <div class="lable-txt">商品详情</div>
        <div class="parameter" v-html="goodsData.ProContent"></div>
        
      </div>
    </div>
  </div>
</template>
<script>
import {
  BusinessDetail,
  BusinessSpuDetailRecommend,
  ShoppingCartAdd,
  
} from "../api/api"
export default {
  name: 'goodsDetail',
  data(){
    return{
      activeindex: 0,
      step: 0,
      imgUrl: null,
      goodsData: {},
      giftsData: [],
      envelopeList: [], // 红包列表
      recommendList: [], // 推荐商品
      skuNumber: 1,
      imgList:[
        {
          id: 1,
          name: '11111'
        },{
          id: 2,
          name: '22222'
        },{
          id: 3,
          name: '33333'
        },{
          id: 4,
          name: '44444'
        },{
          id: 5,
          name: '55555'
        },{
          id: 6,
          name: '66666'
        },
      ]
    }
  },
  created(){
    this.getGoodsDetail()
    this.getRecommend()
  },
  mounted(){

  },
  methods: {
    gotoShop(){
      this.$router.push('/shop')
    },
    getGoodsDetail(){
      let params = {
        spuId: this.$route.query.spuId
      }
      BusinessDetail(params).then(res => {
        if(res.data.success){
          this.goodsData = res.data.response
          this.imgList = res.data.response.Pics || []
          this.imgUrl = this.imgList[0].SpuPicUrl
          this.giftsData = res.data.response.Gifts || []
          this.envelopeList = res.data.response.EnvelopeList || []
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    getRecommend(){
      let params = {
        spuId: this.$route.query.spuId
      }
      BusinessSpuDetailRecommend(params).then(res => {
        if(res.data.success){
          let list = res.data.response || []
          if(list.length >= 4){
            this.recommendList = list.slice(0,4)
          } else{
            this.recommendList = list
          }
        } else{
          this.$message.error(res.data.msg)
        }
      })
    },
    addToCart(){
      let params = {
        skuId: this.goodsData.Skus[0].Id,
        skuNumber: this.skuNumber
      }
      ShoppingCartAdd(params).then(res => {
        if(res.data.success){
          this.$message.success(res.data.msg)
          this.$router.push({path: '/shoppingCart'})
        } else {
          this.$message.error(res.data.msg)
          if(res.data.code == 'nologin'){
            this.$router.push('/login')
          }
        }
      })
    },
    buyNow(){
      this.$router.push({path: '/goodsOrder', query: {
        skuId: this.goodsData.Skus[0].Id,
        skuNumber: this.skuNumber
      }})
      // DirectSettleList().then(res =>{
      //   if(res.data.success){

      //   } else{
      //     this.$message.error(res.data.msg)
      //   }
      // })
    },
    clickImgFun(v,i){
      this.activeindex = i
      this.imgUrl = v.SpuPicUrl
    },
    prevBtn(){
      if(this.step < this.imgList.length%2){
        this.step += 1
      }
      this.$refs.uls.style.left = -(this.step*88) + 'px'

    },
    nextBtn(){
      if(this.step > 0){
        this.step -= 1
      }
      this.$refs.uls.style.left = -(this.step*88) + 'px'
    }
  }
}
</script>
<style lang="scss" scoped>
.img-big-box{
  background: #fff;
}
.redTxt{
  font-size: 24px;
  font-weight: bold;
  color: #f40000;
}
.lineTxt{
  font-size: 18px;
  color: #999;
  text-decoration: line-through;
  margin-left: 6px;
}
.goods-detail{
  width: 1200px;
  margin: 0 auto;
  padding: 33px 0 48px;
  display: flex;
  justify-content: space-between;
  .main-img-box{
    width: 440px;
    .main-img{
      width: 438px;
      height: 438px;
      border: 1px solid #efefef;
      margin-bottom: 21px;
      background: #fff;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .img-list{
      .img-box{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .icon-box{
          width: 35px;
          height: 70px;
          font-size: 30px;
          line-height: 70px;
          color: #dedede;       
          border: 1px solid #EFEFEF;
          cursor: pointer;
        }
        .imgs{
          margin: 0 16px;
          width: 370px;
          height: 73px;
          position: relative;
          overflow: hidden;
          .uls{
            display: flex;
            justify-content: flex-start;
            align-items: center;
            position: absolute;
            li{
              width: 70px;
              height: 70px;
              border: 1px solid #d8d8d8;
              margin-right: 16px;
              cursor: pointer;
              >img{
                width: 100%;
                height: 100%;
              }
            }
            .active{
              border: 1px solid #F40000;;
            }
          }
        }
      }
    }
  }
  .img-right{
    width: 531px;
    padding-top: 39px;
    text-align: left;
    font-size: 14px;
    color: #666;
    .txt-box{
      font-size: 20px;
      font-weight: bold;
      color: #333;
      line-height: 28px;
      text-align: left;
      margin-bottom: 16px;
    }
    .price-box{
      background: #F9F9F9;
      border: 1px solid #E1E1E1;
      padding: 18px 0 25px 13px;
      margin-bottom: 16px;
      .price{
        margin-bottom: 16px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        span{
          display: inline-block;
        }
        .price-title{
          width: 86px;
        }
        .item-gift{
          display: block;
          line-height: 18px;
          margin-bottom: 10px;
        }
        .item-gift:before{
          content: url(../assets/zengpin.png);
          margin-right: 10px;
          display: inline;
          vertical-align: middle;
        }
        .item-red{
          display: block;
          line-height: 18px;
          margin-bottom: 10px;
        }
        .item-red::before{
          content: url(../assets/hongbao.png);
          margin-right: 10px;
          display: inline;
          vertical-align: middle;
        }
      }
    }
    .specs-box{
      padding-left: 14px;
      .specs{
        margin-bottom: 18px;
        span{
          display: inline-block;
        }
        .specs-title{
          width: 83px;
        }
        .specs-list{
          display: inline-block;
          >span{
            border: 1px solid #ccc;
            padding: 4px 10px;
          }
        }
      }
    }
    .btn-box{
      margin-top: 36px;
      padding-left: 14px;
      .inputNum{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-bottom: 20px;
        >span{
          display: inline-block;
          width: 82px;
        }
      }
      .btn{
        font-size: 20px;
        font-weight: bold;
        color: #F40000;
        line-height: 28px;
        padding: 13px 37px;
        float: left;
        margin-right: 26px;
        cursor: pointer;
      }
      .borBtn{
        height: 28px;
        border: 2px solid #F40000;
      }
      .bgBtn{
        height: 32px;
        line-height: 30px;
        background: #F40000;
        color: #fff;
      }
      .icons{
        color: #F40000;
        font-size: 17px;
      }
      .shoucang{
        float: left;
        margin-right: 20px;
        margin-left: 10px;
        line-height: 60px;
        .icon-sc{
          display: inline-block;
          height: 18px;
          line-height: 18px;
        }
        .icon-sc::before{
          content: url(../assets/icon/stars.png);
          margin-right: 5px;
          display: inline;
          vertical-align: middle;
        }
      }
      .kefu{
        float: left;
        line-height: 60px;
        .icon-kf{
          display: inline-block;
          height: 18px;
          line-height: 18px;
        }
        .icon-kf::before{
          content: url(../assets/icon/kefu.png);
          margin-right: 5px;
          display: inline;
          vertical-align: middle;
        }
      }
    }
  }
}
.main-bottom{
  width: 1200px;
  margin: 0 auto;
  .lable-txt{
    text-align: left;
    font-size: 18px;
    font-weight: bold;
    color: #333;
    line-height: 25px;
    margin-bottom: 16px;
  }
}
.shop{
  text-align: left;
  width: 200px;
  font-size: 16px;
  line-height: 24px;
  border: 1px solid #E1E1E1;
  .shop-name{
    border-bottom: 1px solid #E1E1E1;
    padding: 10px;
    font-weight: bold;
  }
  .score{
    border-bottom: 1px solid #E1E1E1;
    padding: 10px;
  }
  .shop-score{
    border-bottom: 1px solid #E1E1E1;
    padding: 10px;
    >p{
      margin-bottom: 10px;
    }
  }
  .describe{
    border-bottom: 1px solid #E1E1E1;
    padding: 10px;
  }
  .shop-btn{
    border-bottom: 1px solid #E1E1E1;
    padding: 10px;
    text-align: center;
  }
}
</style>